<template>
  <div class="form__group">
    <slot/>
  </div>
</template>

<script>
export default {};
</script>
